import * as FilesAPI from "./files.service";
import {chunkSize} from "./files.service";
import axios from "axios";
import {getAuthorization} from "./util.service";
import {checkEmpty} from "../utils/janus.utils";
import {v4 as uuidv4} from "uuid";
import {getClassAndType, getFinalName, sizeToBytse} from "./files.util";

let blobSlice = File.prototype.slice;

export function likeFeed(feedId: string) {
    return axios.put(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/feeds/like/${feedId}`,
        {},
        {
            headers: {
                Authorization: getAuthorization(),
            },
        }
    ).then((res) => res.data);
}

// const apiEditPost = useFetch(
//     window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/feeds/update`,
//     {
//         cachePolicy: CachePolicies.NO_CACHE,
//     }
// );
//
// const apiPost = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/feeds/", {
//     cachePolicy: CachePolicies.NO_CACHE,
// });
//
// const apiUploadFile = useFetch(
//     window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + `/uploadFile`,
//     {
//         cachePolicy: CachePolicies.NO_CACHE,
//     }
// );

export const stickerImageUrls = [
    'sticker-0',
    'sticker-1',
    'sticker-2',
    'sticker-3',
    'sticker-4',
    'sticker-5',
    'sticker-6',
    'sticker-7',
    'sticker-8',
    'sticker-9',
    'sticker-10',
    'sticker-11',
    'sticker-12',
    'sticker-13',
    'sticker-14',
    'sticker-15',
].map((imageName) => `${process.env.PUBLIC_URL}/images/chat-sticker/${imageName}.png`)

export const getStickerSrc = (id: string) => {
    let stickerId = id.split("_")[1];
    if (!stickerId) return;

    let stickerIndex = parseInt(stickerId)
    if (isNaN(stickerIndex)) return;

    return stickerImageUrls[stickerIndex];
}

export const onChangeSelectFileMain = async (
    event: any,
    fileContext: any,
    inputFileToUploadEl: any
) => {
    try {
        // fileContext.setShowModalUpload(true);
        let isCheckIn = false; ///////////////
        let limitPerfileText = fileContext.aboutLimit?.limitSizePerFile;
        let limitSizePerFile = sizeToBytse(limitPerfileText);
        let fileToUploadT = Object.assign([], fileContext.fileToUpload);
        let files = event.target.files;
        console.log("event.target.files", files, files.length)
        fileContext.setCheckingFile(true);
        for (let index = 0; index < event?.target?.files?.length; index++) {
            const {files} = event?.target;
            const file = files?.[index];
            // let file = files[a];
            let d = getClassAndType(file.name);
            d.name_ = await getFinalName(
                d.name_,
                d.type_,
                fileContext.fileToUpload,
                null,
                "",
                fileContext.userId
            );

            file.name_ = d.name_;
            file.fullName = file.name_ + "." + d.type_;
            file.type_ = d.type_;
            file.size_ = file.size;
            file.lastModified_ = file.lastModified;

            let isOversize = false;
            // if (file.size_ > limitSizePerFile) isOversize = true;
            // let already = checkAlready(fileToUploadT, file);
            // console.log("fileToUploadT.push(file);", fileToUploadT, a)
            fileToUploadT.push(file);
            // if (isCheckIn) {
            //     if (
            //         file.name_ === fileContext.fileSelected?.file_name &&
            //         file.type_ === fileContext.fileSelected?.file_type
            //     ) {
            //         fileToUploadT = [];
            //     } else {
            //         //alert
            //         // setMessageNoti(t("Please import same file name as you checked out."));
            //         // setShowNoti(true);
            //     }
            // } else {
                // if (isTrue(fileContext.currentFolder?.control_version)) {
                //     let dataCanUpload: any = await checkFileCanUploadBackend(
                //         file,
                //         fileContext.currentFolder
                //     );
                //     if (isTrue(dataCanUpload.can)) {
                //         if (isOversize === true) {
                //             // setMessageNoti(
                //             //   t("Please select file less than") +
                //             //     " " +
                //             //     aboutLimit.limitSizePerFile
                //             // );
                //             // setShowNoti(true);
                //
                //             fileContext.setUploadErrorMessage("The file is too large.");
                //             fileContext.setUploadErrorDescription(
                //                 "Please select file less than " +
                //                 bytesToSize(limitSizePerFile)?.replace(" ", "")
                //             );
                //         } else {
                //             // fileToUpload.push(file);
                //             fileToUploadT.push(file);
                //             fileContext.setShowModalUpload(true);
                //         }
                //     } else {
                //         //alert
                //         let user_id = dataCanUpload.checkOutObj?.user_id;
                //         // setMessageNoti(
                //         //   t(
                //         //     "${userId} is currently checked out this file. Please wait for ${userId} to cancel check out or check in new file."
                //         //   )
                //         //     .split("${userId}")
                //         //     .join(user_id)
                //         // );
                //         // setShowNoti(true);
                //     }
                // } else {
                //     if (!already) {
                //         if (isOversize) {
                //             // setMessageNoti(
                //             //   t("Please select file less than") +
                //             //     " " +
                //             //     fileContext.aboutLimit.limitSizePerFile
                //             // );
                //             // setShowNoti(true);
                //
                //             fileContext.setUploadErrorMessage("The file is too large.");
                //             fileContext.setUploadErrorDescription(
                //                 "Please select file less than " +
                //                 bytesToSize(limitSizePerFile)?.replace(" ", "")
                //             );
                //         } else {
                //             fileToUploadT.push(file);
                //             fileContext.setShowModalUpload(true);
                //         }
                    // }
                // }
            // }
            // fileContext.setFileToUpload(Object.assign([], fileToUploadT));
        }
        console.log("fileToUploadT", fileToUploadT)
        fileContext.setCheckingFile(false);
        fileContext.setFileToUpload(Object.assign([], fileToUploadT));
        inputFileToUploadEl.current.value = null;
    } catch (e) {
        console.error(e);
    }
};

function onUploadProgress(
    progressEvent: any,
    file: any,
    fileContext: any,
    cancel: any,
    useName: any,
    hash: any,
    index: any,
    total: any
) {

}

function oncancelUpload(file: any, fileContext: any, status: any) {

}

async function uploadFileRequestChunk(
    files: any,
    groupId: any,
    userId: any,
    currentFolder: any,
    isCheckIn: any,
    fileSelected: any,
    fileContext: any
) {
    return new Promise((resolve, reject) => {
        let sizeAll = files.length,
            checkFinish = 0,
            checkError = 0;
        let parentFolderId = "";
        if (!checkEmpty(currentFolder?.file_app_id))
            parentFolderId = currentFolder?.file_app_id;

        let lsFileUpload: any = [];
        let fileTemps: any = [];
        for (let a = 0; a < files.length; a++) {
            let file = files[a];

            let usedId: any = null;
            let useName = file.name_;
            if (isCheckIn) {
                usedId = fileSelected.file_app_id;
                useName = fileSelected.file_name;
            }

            let blockCount = Math.ceil(file.size / chunkSize); // total number of fragments
            console.log("a ", a);

            let hash = uuidv4();
            console.log("hash", hash);
            let axiosPromiseArray = [];

            let fileTemp: any = { loaded: 0 };
            fileTemps[a] = fileTemp;

            console.log(a, blockCount);
            for (let i = 0; i < blockCount; i++) {
                let CancelToken = axios.CancelToken;
                let cancel: any;
                const start = i * chunkSize;
                const end = Math.min(file.size, start + chunkSize);
                // Building forms
                const form = new FormData();
                form.append("file", blobSlice.call(file, start, end));
                form.append("name", useName);
                //@ts-ignore
                form.append("total", blockCount);
                //@ts-ignore
                form.append("index", i);
                form.append("size", file.size);
                //@ts-ignore
                form.append("hash", hash);

                // Ajax submits fragmentation, where content-type is multipart/form-data

                const axiosOptions = {
                    onUploadProgress: (e: any) => {
                        // Progress in handling uploads
                        let progress: any = {};
                        let loaded = fileTemps[a].loaded + e.loaded;
                        progress.total = file.size;
                        progress.loaded = loaded;
                        if (e.loaded === e.total) {
                            fileTemps[a].loaded = fileTemps[a].loaded + e.total;
                        }

                        onUploadProgress(
                            progress,
                            file,
                            fileContext,
                            cancel,
                            useName,
                            hash,
                            i,
                            blockCount
                        );
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: getAuthorization(),
                    },
                    cancelToken: new CancelToken(function executor(c) {
                        // An executor function receives a cancel function as a parameter
                        cancel = c;
                    }),
                };
                // Add to Promise array
                let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/uploadSplit";
                axiosPromiseArray.push(axios.post(link, form, axiosOptions));
            }
            // After all fragments are uploaded, request to merge the fragmented files
            console.log("a ", a, axiosPromiseArray);
            axios
                .all(axiosPromiseArray)
                .then(() => {
                    let CancelToken = axios.CancelToken;
                    let cancel: any;

                    let config = {
                        cancelToken: new CancelToken(function executor(c) {
                            // An executor function receives a cancel function as a parameter
                            cancel = c;
                        }),
                        onUploadProgress: (progress: any) => {
                            // onUploadProgress(progress, file, fileContext, cancel);
                            let progressT: any = {};
                            progressT.total = file.size;
                            progressT.loaded = file.size;
                            onUploadProgress(
                                progressT,
                                file,
                                fileContext,
                                cancel,
                                useName,
                                hash,
                                null,
                                blockCount
                            );
                        },
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: getAuthorization(),
                        },
                    };

                    let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/merge_chunks";
                    // Merge chunks
                    console.log("file : ", file);
                    const data = {
                        size: file.size,
                        name: useName + "." + file.type_,
                        total: blockCount,

                        fileName: useName,
                        userId: userId,
                        groupId: groupId,
                        parentFolderId: parentFolderId,
                        cancelCheckOut: isCheckIn,
                        cancelCheckOutFileId: usedId,
                        hash: hash,
                        mimeType: file.type,
                    };
                    axios
                        .post(link, data, config)
                        .then((res) => {
                            console.log("successful upload");
                            console.log(res.data, file);
                            let fileT = Object.assign({}, res.data.data);
                            lsFileUpload.push(fileT);
                            checkFinish++;
                            let progressT: any = {};
                            progressT.total = file.size;
                            progressT.loaded = file.size;
                            onUploadProgress(
                                progressT,
                                file,
                                fileContext,
                                cancel,
                                useName,
                                hash,
                                null,
                                blockCount
                            );
                            if (checkFinish === sizeAll && checkError === 0) {
                                // resolve(lsFileUpload);
                                resolve(lsFileUpload.map(function (cover: any) {
                                    console.log("cover", cover)
                                    return {
                                        imageID: cover.id,
                                        title: cover.fileName,
                                        coverKind: cover?.mime_type?.includes("video") ? "video" : "image",
                                    };
                                }))
                            } else if (checkFinish === sizeAll && checkError != 0) {
                                // resolve(lsFileUpload);
                                resolve(lsFileUpload.map(function (cover: any) {
                                    console.log("cover", cover)
                                    return {
                                        imageID: cover.id,
                                        title: cover.fileName,
                                        coverKind: cover.mime_type?.includes("video") ? "video" : "image",
                                    };
                                }))
                            }

                            // let fileT = Object.assign({}, res.data.data);
                            // lsFileUpload.push(fileT);
                        })
                        .catch(function (error) {
                            checkError++;
                            if (axios.isCancel(error)) {
                                oncancelUpload(file, fileContext, "cancel");
                            } else {
                                console.log("some other reason", error);
                                oncancelUpload(file, fileContext, "error");
                            }
                        })
                        .finally(function () {
                            console.log("finally upload");
                        });
                })
                .catch(function (error) {
                    checkError++;
                    if (axios.isCancel(error)) {
                        oncancelUpload(file, fileContext, "cancel");
                    } else {
                        console.log("some other reason", error);
                        oncancelUpload(file, fileContext, "error");
                    }
                });
        }
    });
}

const uploadPostCovers = async (fileCovers: any) => {
    return new Promise(async (resolve, reject) => {
        // const listResponseUpload: any = [];
        let axiosPromiseArray: any = [];
        const items = Object.assign([], fileCovers);
        for (let item of items) {
            console.log("::>> item", item);
            const axiosOptions = {
                // onUploadProgress: (e: any) => {
                // },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
                // cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                //     cancel = c;
                // }),
            };
            // Add to Promise array
            let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + `/uploadFile`;
            axiosPromiseArray.push(axios.post(link, item?.fileData, axiosOptions));
        }

        axios
            .all(axiosPromiseArray)
            .then(function (covers) {
                resolve(covers.map(function (cover: any) {
                    console.log("cover", cover)
                    return {
                        imageID: cover.data.data.id,
                        title: cover.data.data.fileName,
                        coverKind: cover.data.data?.mime_type?.includes("video") ? "video" : "image",
                    };
                }))
            }).catch(function (error) {
                reject(error);
            })
    })
}

const uploadFeedFiles = async (fileCovers: any, groupId: any, userId: any, currentFolder: any) => {
    let res = await uploadFileRequestChunk(fileCovers, groupId, userId, currentFolder, false, null, null);
}

const uploadImage = async (fileCovers: any) => {
    const listResponseUpload: any = [];
    const items = Object.assign([], fileCovers);
    try {
        for (let item of items) {
            console.log("::>> item", item);

            let responseData = await axios
                .post(window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + `/uploadFile`, item?.fileData, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: getAuthorization(),
                    },
                })
            // .then(function (response) {
            //     // resolve(response.data.data);
            // })
            // .catch(function (error) {
            //     // reject(error);
            // })
            // .finally(function () {
            //     // always executed
            // });
            // const responseData = await apiUploadFile.post(item?.fileData);
            console.log("::>> responseData", responseData);

            if (responseData?.data.success) {
                let responseUpload = {
                    imageID: responseData.data.data.id,
                    title: responseData.data.data.fileName,
                    coverKind: item?.fileType?.includes("video") ? "video" : "image",
                };
                listResponseUpload.push(responseUpload);
            }


        }
        console.log(":: listResponseUpload", listResponseUpload);
    } catch (error) {
        console.error("Error UploadFile : ", error);
        return [];
    }
    return listResponseUpload;
};

const getCoversList = (postId: any, isEditPost: boolean, previewCovers: any, newCovers: any, oldcover: any) => {
    const coversArr: any = [];
    const coversDeleteArr: any = [];

    console.log("newCovers.length", newCovers.length);
    if (isEditPost) {
        const oldCovers =
            previewCovers !== null
                ? previewCovers.filter((cover: any) => {
                    return cover.imageID;
                })
                : [];

        if (oldCovers.length > 0) {
            oldCovers.forEach((item: any) => {
                coversArr.push({
                    id: item?.id,
                    imageID: item?.imageID,
                    feedId: postId,
                    coverLink: item?.coverLink,
                    coverKind: item?.coverKind,
                });
            });
        }
        const fileServiceDownloadURL = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";
        if (newCovers.length > 0) {
            newCovers.forEach(async (item: any) => {
                let url: any = fileServiceDownloadURL + item?.imageID + "&size=1024";
                url = await FilesAPI.getUrl(url, item?.imageID, 1024, "post");

                coversArr.push({
                    imageID: item?.imageID,
                    feedId: postId,
                    coverLink: url,
                    coverKind: item?.coverKind,
                });
            });
        }

        if (oldcover?.covers !== null) {
            console.log("coversArr=>", coversArr);

            for (const oc of oldcover) {
                if (
                    !coversArr?.some(
                        (cover: any) => cover?.imageID === oc?.imageID
                    )
                ) {
                    coversDeleteArr.push({
                        action: "delete",
                        id: oc?.id,
                        imageID: oc?.imageID,
                        feedId: oc.postID,
                        coverLink: oc?.coverLink,
                        coverKind: oc?.coverKind,
                    });
                }
            }
        }
    } else {
        if (newCovers) {
            newCovers.forEach((cover: any) => coversArr.push(cover));
        }
    }
    return [...coversArr, ...coversDeleteArr];
};

export async function publishFeed(feed: any) {
    return await publishPost(
        feed.user,
        feed.userId,
        feed.postId,
        feed.title,
        feed.content,
        feed.privacy,
        feed.mentions,
        feed.feedKind,
        feed.groupId,
        feed.isEditPost,
        feed.fileCovers,
        feed.fileToUpload,
        feed.tagList,
        feed.categoryList,
        feed.styleContent,
        feed.previewCovers,
        feed.oldcover,
        feed.feedContext,
        () => {},
        () => {},
        () => {},
    );
}

export async function postFeed(
    user: any,
    userId: string,
    postId: string,
    title: any,
    content: any,
    privacy: any,
    // covers: any,
    // categories: any,
    mentions: any,
    feedKind: string,
    groupId: string,
    // styleContent: string,
    isEditPost: boolean,
    fileCovers: any,
    fileToUpload: any,
    tagList: any,
    categoryList: any,
    styleContent: any,
    previewCovers: any,
    oldcover: any,
    feedContext: any,
    onSuccess: any,
    onError: any,
    callback: any
) {
    const fileSize = fileCovers?.length ? fileCovers?.length : 0;
    console.log("fileCovers",fileCovers)
    // return;
    // const tagList = getTagsList(postCtx.tag);
    // const categoryList = await getCategoryList(postCtx.category);
    const covers: any = await uploadPostCovers(fileCovers);
    //const covers: any = await uploadFileRequestChunk(fileToUpload, groupId, userId, null, false, null, null);
    const coversArrObj = getCoversList(postId, isEditPost, previewCovers, covers, oldcover);
    // const styleContent = {
    //     textAlign: captionAlign,
    //     backgroundColor: captionBgColor,
    //     textDecoration: captionUnderline,
    //     fontWeight: captionStyle,
    //     fontStyle: captionItalic,
    // };
    console.log("covers => ", covers);
    console.log("รูปที่จะลง db => ", coversArrObj);

    if (fileSize !== covers.length) {
        console.log("fileSize !== covers.length")
        try {
            onError();
        } catch (e) {

        }
        // openNotificationWithIcon('error', t("Post error"), t("post not success."));
        return;
    }

    if (isEditPost) {
        coversArrObj.push(...covers);
    }

    let postData = {
        type: "post",
        title: title,
        content: content,
        userID: userId,
        privacy: privacy,
        covers: coversArrObj,
        categories: categoryList,
        mentions: tagList,
        feedKind: "post",
        groupID: groupId,
        styleContent: JSON.stringify(styleContent),
    };

    let res: any;
    if (isEditPost) {
        // res = await apiEditPost.put(postData);

        axios
            .put(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/feeds/update/${postId}`, postData, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
            })
            .then(function (response) {
                // resolve(response.data.data);
                try {
                    onSuccess();
                    callback();
                } catch (e) {
                    console.log("can't callback")
                }
            })
            .catch(function (error) {
                // reject(error);
                try {
                    onError();
                } catch (e) {

                }
            })
            .finally(function () {
                // always executed
            });
        // res = await apiEditPost.put(`/${postId}`);
    } else {
        axios
            .post(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/feeds/", postData, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
            })
            .then(function (response) {
                // resolve(response.data.data);
                res = response.data;
                res = Object.assign(res, {
                    user: user,
                });

                if (res.privacy !== "draft") {
                    // feedContext.setFeeds((prev: any) => {
                    //     const feedList: any = [...prev.feeds];
                    //     feedList.push(res);
                    //     feedList.sort((a: any, b: any) => {
                    //         if (a.createdAt > b.createdAt) return -1;
                    //         if (a.createdAt < b.createdAt) return 1;
                    //     });
                    //
                    //     const newFeedsObj = {
                    //         feeds: feedList,
                    //         offset: prev.offset,
                    //         total: prev.total,
                    //     };
                    //
                    //     return newFeedsObj;
                    // });
                    // props.onRefresh();
                }
                try {
                    onSuccess();
                    callback();
                } catch (e) {
                    console.log("can't callback")
                }
            })
            .catch(function (error) {
                // reject(error);
                try {
                    onError();
                } catch (e) {

                }
            })
            .finally(function () {
                // always executed
            });
        // res = await apiPost.post(postData);
    }

    // postCtx.setOldData(null);
    // postCtx.setOldcover(null);
    // postCtx.setPostID(null);
    // postCtx.setIsEditPost(false);
    // openNotificationWithIcon('success', t("You have successfully posted."), t(""));
    // appCtx.setEnableBeforeUnload(false);
    // resetCreatePost();
}

export async function publishPost(
    user: any,
    userId: string,
    postId: string,
    title: any,
    content: any,
    privacy: any,
    // covers: any,
    // categories: any,
    mentions: any,
    feedKind: string,
    groupId: string,
    // styleContent: string,
    isEditPost: boolean,
    fileCovers: any,
    fileToUpload: any,
    tagList: any,
    categoryList: any,
    styleContent: any,
    previewCovers: any,
    oldcover: any,
    feedContext: any,
    onSuccess: any,
    onError: any,
    callback: any
) {
    const fileSize = fileCovers?.length ? fileCovers?.length : 0;
    console.log("fileCovers",fileCovers)
    // return;
    // const tagList = getTagsList(postCtx.tag);
    // const categoryList = await getCategoryList(postCtx.category);
    const covers: any = await uploadPostCovers(fileCovers);
    //const covers: any = await uploadFileRequestChunk(fileToUpload, groupId, userId, null, false, null, null);
    const coversArrObj = getCoversList(postId, isEditPost, previewCovers, covers, oldcover);
    // const styleContent = {
    //     textAlign: captionAlign,
    //     backgroundColor: captionBgColor,
    //     textDecoration: captionUnderline,
    //     fontWeight: captionStyle,
    //     fontStyle: captionItalic,
    // };
    console.log("covers => ", covers);
    console.log("รูปที่จะลง db => ", coversArrObj);

    if (fileSize !== covers.length) {
        console.log("fileSize !== covers.length")
        try {
            onError();
        } catch (e) {

        }
        // openNotificationWithIcon('error', t("Post error"), t("post not success."));
        return;
    }

    if (isEditPost) {
        coversArrObj.push(...covers);
    }

    let postData = {
        type: "post",
        title: title,
        content: content,
        userID: userId,
        privacy: privacy,
        covers: coversArrObj,
        categories: categoryList,
        mentions: tagList,
        feedKind: "post",
        groupID: groupId,
        styleContent: JSON.stringify(styleContent),
    };

    let res: any;
    if (isEditPost) {
        // res = await apiEditPost.put(postData);

        return axios
            .put(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/feeds/update/${postId}`, postData, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
            }).then(res => res.data)
        // res = await apiEditPost.put(`/${postId}`);
    } else {
        return axios
            .post(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/feeds/", postData, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
            })
            .then(res => res.data)
        // res = await apiPost.post(postData);
    }

    // postCtx.setOldData(null);
    // postCtx.setOldcover(null);
    // postCtx.setPostID(null);
    // postCtx.setIsEditPost(false);
    // openNotificationWithIcon('success', t("You have successfully posted."), t(""));
    // appCtx.setEnableBeforeUnload(false);
    // resetCreatePost();
}